// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__C1o65","bigColWidth":"Table_bigColWidth__10Dmq","biggerColWidth":"Table_biggerColWidth__2Rm2B","row":"Table_row__365ot","col":"Table_col__2Abt9"};